import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown, ChevronRight } from 'lucide-react'

interface PantryExclusionDisclosureProps {
  count: number
  names: string[]
}

export function PantryExclusionDisclosure({ count, names }: PantryExclusionDisclosureProps) {
  const { t } = useTranslation('grocery-list')
  const [expanded, setExpanded] = useState(false)

  if (count === 0) return null

  return (
    <div className="print:hidden">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label={t('pantryExclusion.ariaLabel')}
        className="flex items-center gap-1 text-xs text-muted hover:text-ink transition-colors"
      >
        {expanded ? (
          <ChevronDown className="h-3 w-3" aria-hidden="true" />
        ) : (
          <ChevronRight className="h-3 w-3" aria-hidden="true" />
        )}
        <span>{t('pantryExclusion.text', { count })}</span>
      </button>
      {expanded && (
        <ul className="ml-4 mt-1 text-xs text-muted list-disc list-inside">
          {names.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
